'use strict';

var React = require('react');
var _require = require('@sanity/block-content-to-hyperscript/internals'),
  getSerializers = _require.getSerializers;
var renderNode = React.createElement;
var _getSerializers = getSerializers(renderNode),
  defaultSerializers = _getSerializers.defaultSerializers,
  serializeSpan = _getSerializers.serializeSpan;
module.exports = {
  serializeSpan: serializeSpan,
  serializers: defaultSerializers,
  renderProps: {
    nestMarks: true
  }
};